import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { ReactElement } from 'react';

import { Wrapper } from './styles';
import { CalmLogoColor, CalmLogoProps } from './types';

const CalmLogo = ({
	className,
	height = 40,
	href = '/',
	color = CalmLogoColor.White,
	loader,
	preserveQueryParams = true,
	'aria-label': ariaLabel = 'Calm Logo - Link to Homepage',
	'data-testid': dataTestId = 'calm-logo',
}: CalmLogoProps): ReactElement => {
	const queryParams = useSearchParams();
	const queryString = queryParams?.toString() ?? '';
	const linkHref = preserveQueryParams && queryString ? `${href}?${queryString}` : href;

	const isWhite = color === CalmLogoColor.White;
	const actualWidth = 103;
	const actualHeight = 41;
	const aspectRatio = actualWidth / actualHeight;
	const width = height * aspectRatio;
	const src = isWhite ? '/_n/images/calm-logo.svg' : '/_n/images/calm-logo-gradient.svg';
	return (
		<Wrapper className={className} $width={width} $height={height} href={linkHref} aria-label={ariaLabel}>
			<Image
				width={actualWidth}
				height={actualHeight}
				src={src}
				loader={loader}
				alt="Calm logo"
				unoptimized
				data-testid={dataTestId}
				style={{ width: 'auto', height: `${height}px` }}
			/>
		</Wrapper>
	);
};
export default CalmLogo;
